import { useUserStore } from '@/stores/user'

export default {
  mounted(el, binding) {
    const { value } = binding
    const store = useUserStore()

    if (!value) return

    let allowed = false
    // 支持两种用法：v-permission="'code'" 或 v-permission="{ permission:'code', requireAll:false }"
    if (typeof value === 'string') {
      allowed = store.permissions?.includes(value)
    } else if (typeof value === 'object' && value.permission) {
      const codes = Array.isArray(value.permission) ? value.permission : [value.permission]
      if (value.requireAll) {
        allowed = codes.every(c => store.permissions?.includes(c))
      } else {
        allowed = codes.some(c => store.permissions?.includes(c))
      }
    }

    if (!allowed) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
} 